<style lang="scss" scoped>
@import '$vars';
.vector {
  min-width: 10px;
}
.color-white {
  fill: #fff
}
.color-gray {
  fill: #999
}
.color-acqua {
  fill: $color-acqua
}
.color-blue {
  fill: $color-blue
}
.color-green {
  fill: $color-green
}
.color-navy {
  fill: $color-navy
}
.color-gradient {
  fill: url(#linearGradient-1)
}
.color-yellow {
  fill: #ffb700;
}
.color-red {
  fill: $color-red;
}
div {
  line-height: 0
}
</style>

<template>
  <figure>
    <div :class="'color-' + localFill" :style="'fill: '+ color">
      <svg :viewBox="getViewBox" class="vector">
        {{getViewBox}}
        <linearGradient id="linearGradient-1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color:#4bace5;stop-opacity:1" />
          <stop offset="60%" style="stop-color:rgba(80, 227, 194, 1);stop-opacity:1" />
        </linearGradient>
        <g v-html="getSrc"></g>
      </svg>
    </div>
  </figure>
</template>

<script>
export default {
  props: [ 'src', 'fill', 'color', 'size' ],

  data () {
    return {
      localFill: this.fill
    }
  },

  computed: {
    getSrc () {
      return this.src.replace(/[<svg.*^>,</svg>]/, '')
    },
    getViewBox () {
      if (!this.src.match(/viewBox="[0-9, ]*"/)) {
        return '0 0 0 0'
      }
      return (this.src.match(/viewBox="[0-9, ]*"/)[0]).replace(/[",=,viewBox]/g, '') || ''
    }
  },

  watch: {
    'fill': (next, prev) => {
      this.localFill = next
    }
  },

  mounted () {
    // var gradient = document.getElementById('gradient')
  }
}
</script>
